import { forwardRef, useRef, useImperativeHandle } from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  helper?: string
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helper, className = '', required = false, type, ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null)
    useImperativeHandle(ref, () => inputRef.current!)

    const handleClick = () => {
      if ((type === 'date' || type === 'datetime-local') && inputRef.current) {
        try { inputRef.current.showPicker() } catch { inputRef.current.focus() }
      }
    }

    return (
      <div className={className}>
        {label && <label className="label">{label}{required && <span className="ml-1 text-red-500">*</span>}</label>}
        <input ref={inputRef} type={type} autoComplete="one-time-code" className={`input ${error ? 'input-error' : ''} ${type === 'date' || type === 'datetime-local' ? 'cursor-pointer' : ''}`} onClick={handleClick} {...props} />
        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
        {helper && !error && <p className="mt-1 text-sm text-gray-500">{helper}</p>}
      </div>
    )
  }
)
Input.displayName = 'Input'
export default Input
